var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationCloseX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationCloseX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-417.000000, -671.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-uploaded",
    transform: "translate(75.000000, 663.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.739669,13 L351.636077,15.8964085 C352.118152,16.3784833 352.122862,17.155371 351.639117,17.6391165 C351.15872,18.1195128 350.382421,18.1220893 349.896409,17.6360772 L347,14.7396687 L344.103591,17.6360772 C343.621517,18.118152 342.844629,18.122862 342.360883,17.6391165 C341.880487,17.1587203 341.877911,16.3824206 342.363923,15.8964085 L345.260331,13 L342.363923,10.1035915 C341.881848,9.62151667 341.877138,8.84462897 342.360883,8.36088349 C342.84128,7.88048724 343.617579,7.87791072 344.103591,8.36392278 L347,11.2603313 L349.896409,8.36392278 C350.378483,7.88184798 351.155371,7.87713801 351.639117,8.36088349 C352.119513,8.84127973 352.122089,9.61757942 351.636077,10.1035915 L348.739669,13 Z",
    id: "icNotificationCloseX"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationCloseX);
export default __webpack_public_path__ + "static/media/icNotificationCloseX.0f1c9492690d06c8b86e2cd794cb0991.svg";
export { ForwardRef as ReactComponent };